<itm-modal #modalWarning [id]="'warning-modal'" [cssClassModalSize]="''">
	<div class="modal-header">
		<h5 class="modal-title">Warning</h5>
		<button (click)="modalWarning.hide()" type="button" class="close" aria-label="Close">
			<span aria-hidden="true">x</span>
		</button>
	</div>
	<div class="modal-body">
		<ul *ngIf="profileData && profileData.showWarning">
			<li *ngFor="let m of profileData.messages; let i = index;">{{ m.msg }}</li>
		</ul>
	</div>
</itm-modal>
<div [class.d-none]="!showLoading">
	<itm-spinner></itm-spinner>
</div>
<app-alert></app-alert>
<nav *ngIf="currentUser && currentUser.profilo != 'D'" class="navbar navbar-expand-xxl site-header sticky-top py-1 py-xl-4 navbar-light justy">
	<a class="py-2 navbar-brand" routerLink="dashboard">
		DS
	</a>
	<button *ngIf="currentUser.profilo_valido" class="navbar-toggler" type="button" data-toggle="collapse"
		data-target="#navbarTogglerHeaderMenu" aria-controls="navbarTogglerHeaderMenu" aria-expanded="false"
		aria-label="Toggle navigation">
		<i class="fas fa-bars"></i>
	</button>

	<div *ngIf="currentUser.profilo_valido" class="collapse navbar-collapse justify-content-center"
		id="navbarTogglerHeaderMenu">

		<ul class="navbar-nav">
			<li class="nav-item d-block d-xxl-none border-bottom">
				<a class="nav-link py-2 d-md-inline-block user-link font-weight-bold">{{ "common.ciao" | translate }}, {{
					currentUser.username }}!</a>
			</li>
			<li class="nav-item" *ngIf="menu.DAS && menu.DAS.visibile"><a [attr.disabled]="!menu.DAS || !menu.DAS.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.DAS || !menu.DAS.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="dashboard">{{ "menu.dashboard" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.SER.visibile"><a [attr.disabled]="!menu.SER.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.SER.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					[routerLinkActiveOptions]="{exact: true}" routerLink="services">{{ "menu.servizi" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.AGE.visibile"><a [attr.disabled]="!menu.AGE.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.AGE.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="scheduler">{{ "menu.agenda" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.CLI.visibile"><a [attr.disabled]="!menu.CLI.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.CLI.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="customers">{{ "menu.clienti" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.LIS.visibile"><a [attr.disabled]="!menu.LIS.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.LIS.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="pricelists">{{ "menu.listini" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.NET.visibile"><a [attr.disabled]="!menu.NET.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.NET.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="network">{{ "menu.network" | translate }}</a></li>
			<li class="nav-item" *ngIf="menu.APA.visibile"><a [attr.disabled]="!menu.APA.abilitato"
					class="nav-link py-2 d-md-inline-block" [ngClass]="{'disabled': !menu.APA.abilitato}" (click)="toggleMenu()" routerLinkActive="active"
					routerLink="driver-app/services">{{ "menu.app_autista" | translate }}</a></li>
			<li class="nav-item d-block d-xxl-none"><a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()"
					routerLinkActive="active" routerLink="account">{{ "menu.profilo_utente" | translate }}</a></li>
			<li class="nav-item d-block d-xxl-none"><a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()"
					routerLink="logout">{{
					"menu.logout" | translate }}</a></li>
		</ul>

	</div>
	<div id="secondary-links" class="justify-content-end d-none d-xxl-block" id="navbarTogglerUserMenu">
		<ng-container *ngIf="currentUser.profilo_valido">
			<a class="nav-link py-2 d-md-inline-block user-link">{{ "common.ciao" | translate }},
				<span>{{ currentUser.username }}</span>!</a>
			<a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()" routerLink="account"><i
					class="far fa-user"></i></a>
			<a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()" [routerLink]="">
				<span *ngIf="profileData && profileData.showWarning" (click)="showWarning()" class="warning-notify fa-stack"
					[attr.data-count]="profileData.messages.length">
					<i class="far fa-bell"></i>
				</span>
				<i *ngIf="!profileData || !profileData.showWarning" class="far fa-bell"></i>
			</a>
		</ng-container>
		<a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()" routerLink="logout"><i
				class="fas fa-sign-out-alt"></i></a>
	</div>
</nav>

<nav *ngIf="currentUser && currentUser.profilo == 'D'" class="navbar navbar-expand-xxl site-header sticky-top py-4 navbar-light justy">
	<a class="py-2 navbar-brand" routerLink="driver-app/services">
		DS
	</a>
	<a class="nav-link py-2 d-md-inline-block" (click)="toggleMenu()" routerLink="logout"><i
		class="fas fa-sign-out-alt"></i></a>
</nav>

<div class="main">
	<router-outlet></router-outlet>
</div>

<footer *ngIf="currentUser" class="d-none d-lg-block page-footer font-small blue">

	<div class="footer-copyright text-center pt-3">
		v. web <b>{{ versione }}</b> | v. api <b>{{ versioneBE }}</b></div>
		<div class="footer-copyright text-center py-1">&copy; {{ year }} Copyright: <a target="_blank" href="mailto:staff@it-mind.it">
			it-mind.it</a>
	</div>

</footer>